import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { formGroupConnect, noop } from '@groove-labs/groove-ui';
import SelectableCheckboxGroup from 'Modules/Shared/components/SelectableCheckboxGroup';

const styles = theme => ({
  container: {
    display: 'flex',
    maxWidth: '100%',
  },
  label: {
    marginRight: 10,
    flex: 1,
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 500,
    width: 34,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    flex: 2,
    paddingBottom: 6,
  },
  paper: {
    overflow: 'auto',
  },
});

@formGroupConnect({ preserveOnUnmount: true })
@withStyles(styles)
class FilterFormSelectableCheckboxGroup extends React.Component {
  static propTypes = {
    classes: PropTypes.shape({
      container: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      select: PropTypes.string.isRequired,
    }).isRequired,
    groupId: PropTypes.string.isRequired,
    fieldId: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    initialValue: PropTypes.string,
    options: ImmutablePropTypes.listOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    onChange: PropTypes.func,
    placeholderText: PropTypes.string,
    selectAll: PropTypes.bool,
    maxMenuHeight: PropTypes.number,
    selectOverride: PropTypes.string,
  };

  static defaultProps = {
    initialValue: '',
    onChange: noop,
    placeholderText: 'Select an item',
    selectAll: false,
    maxMenuHeight: 260,
  };

  render() {
    const {
      groupId,
      fieldId,
      classes,
      label,
      options,
      initialValue,
      onChange,
      selectAll,
      placeholderText,
      maxMenuHeight,
      selectOverride,
    } = this.props;

    return (
      <div className={classes.container}>
        <Typography className={classes.label}>{label}</Typography>
        <SelectableCheckboxGroup
          classes={{
            root: cx(classes.select, selectOverride),
            paper: classes.paper,
          }}
          groupId={groupId}
          fieldId={fieldId}
          placeholderText={placeholderText}
          initialValue={initialValue}
          options={options}
          onChange={onChange}
          selectAll={selectAll}
          maxMenuHeight={maxMenuHeight}
        />
      </div>
    );
  }
}

export default FilterFormSelectableCheckboxGroup;
